import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';
import { mainContentTabNav } from '../_app/main-content/main-content-tab-nav.css';

export const tournamentNav = style([
  mainContentTabNav,
  {
    marginTop: space.s24,
    marginBottom: space.s24,
  },
]);

export const tournamentSection = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s24,
});
export const sectionLabel = style({
  ...responsiveStyle({
    tablet: {
      ...typography.titleMd,
    },
    laptop: {
      ...typography.titleLg,
    },
  }),
});

export const subSectionLabel = style([typography.labelMd]);

export const notFound = style({ padding: space.s24 });
